<template>
  <el-form-item
    v-if="show"
    :prop="propName"
  >
    <custom-select
      v-model="selectedOption"
      :label="label"
      :settings="{ options: orientOptions }"
      :store-object="true"
    />
  </el-form-item>
</template>

<script setup>
import { computed } from 'vue';
import CustomSelect from '@/shared/components/custom_select.vue';

const props = defineProps({
  show: { type: Boolean, required: true },
  propName: { type: String, default: 'OrientacionFibra' },
  label: { type: String, default: 'Orientación de fibra' },
  modelValue: { type: Number, required: true, default: 0 },
});

const emit = defineEmits(['update:modelValue']);

const orientOptions = [
  { Codigo: 0, Descripcion: 'Sin orientación' },
  { Codigo: 1, Descripcion: 'Larga' },
  { Codigo: 2, Descripcion: 'Corta' },
];

const selectedOption = computed({
  get() {
    return orientOptions.find((o) => o.Codigo === props.modelValue);
  },
  set(option) {
    emit('update:modelValue', option?.Codigo ?? 0);
  },
});
</script>
